"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.CLOUD_API_KEY = exports.RECENTLY_VIEWED_CONFIG = exports.CLEAR_ALL = exports.RECENTLY_VIEWED = exports.RECOMMENDED = exports.COMMON_SEARCHES = void 0;
var COMMON_SEARCHES = 'Common Searches';
exports.COMMON_SEARCHES = COMMON_SEARCHES;
var RECOMMENDED = 'Recommended';
exports.RECOMMENDED = RECOMMENDED;
var RECENTLY_VIEWED = 'Recently Viewed';
exports.RECENTLY_VIEWED = RECENTLY_VIEWED;
var CLEAR_ALL = 'Clear All';
exports.CLEAR_ALL = CLEAR_ALL;
var RECENTLY_VIEWED_CONFIG = {
  DISPLAY_ITEM_COUNT: {
    MOBILE: 3,
    DESKTOP: 5
  }
};
exports.RECENTLY_VIEWED_CONFIG = RECENTLY_VIEWED_CONFIG;
var CLOUD_API_KEY = {
  dev: 'XbnTgkZgRwKyNX9a90EdGGTBhvc6IXpk',
  beta: 'XbnTgkZgRwKyNX9a90EdGGTBhvc6IXpk',
  kappa: 'Gfdi01xo7Vej1YETa2vc8z7UNEiANeWN',
  stage: 'XbnTgkZgRwKyNX9a90EdGGTBhvc6IXpk',
  production: 'xbqGCOubdkYYypwETOHerYcReO5MUYdm'
};
exports.CLOUD_API_KEY = CLOUD_API_KEY;